// extracted by mini-css-extract-plugin
export default {"legendaMapa":"Legenda_legendaMapa__c6+j5","item":"Legenda_item__6TGGa","blocoCor":"Legenda_blocoCor__kY43B"};